import { render, staticRenderFns } from "./IssueSeverity.vue?vue&type=template&id=a16defe4&scoped=true"
import script from "./IssueSeverity.vue?vue&type=script&lang=js"
export * from "./IssueSeverity.vue?vue&type=script&lang=js"
import style0 from "./IssueSeverity.vue?vue&type=style&index=0&id=a16defe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16defe4",
  null
  
)

export default component.exports